<template>
  <div class="student-progress">
    <el-row :gutter="20">
      <el-col :span="12">
        <h4>基本信息</h4>
        <el-descriptions :column="1" border>
          <el-descriptions-item label="学员姓名">{{ studentInfo.realName }}</el-descriptions-item>
          <el-descriptions-item label="手机号">{{ studentInfo.phone }}</el-descriptions-item>
          <el-descriptions-item label="课程类型">
            {{ studentInfo.courseType === 'c1' ? 'C1手动挡' : 'C2自动挡' }}
          </el-descriptions-item>
          <el-descriptions-item label="当前科目">
            {{ getSubjectText(studentInfo.currentSubject) }}
          </el-descriptions-item>
        </el-descriptions>
      </el-col>

      <el-col :span="12">
        <h4>学时统计</h4>
        <div class="stats">
          <div class="stat-item">
            <span class="label">总学时:</span>
            <span class="value">{{ studentInfo.totalHours }}小时</span>
          </div>
          <div class="stat-item">
            <span class="label">已完成:</span>
            <span class="value">{{ studentInfo.completedHours }}小时</span>
          </div>
          <div class="stat-item">
            <span class="label">剩余:</span>
            <span class="value">{{ studentInfo.remainingHours }}小时</span>
          </div>
        </div>

        <h4 style="margin-top: 20px;">科目进度</h4>
        <div class="subject-progress">
          <div class="subject-item">
            <span>科目二</span>
            <el-progress
                :percentage="studentInfo.subject2Progress"
                :status="studentInfo.subject2Progress === 100 ? 'success' : ''"
            ></el-progress>
          </div>
          <div class="subject-item">
            <span>科目三</span>
            <el-progress
                :percentage="studentInfo.subject3Progress"
                :status="studentInfo.subject3Progress === 100 ? 'success' : ''"
            ></el-progress>
          </div>
        </div>
      </el-col>
    </el-row>

    <h4 style="margin-top: 20px;">最近训练记录</h4>
    <el-table :data="trainingRecords" size="small">
      <el-table-column prop="date" label="日期" width="100"></el-table-column>
      <el-table-column prop="coachName" label="教练" width="100"></el-table-column>
      <el-table-column prop="subject" label="科目" width="80">
        <template slot-scope="scope">
          {{ scope.row.subject === 'subject2' ? '科目二' : '科目三' }}
        </template>
      </el-table-column>
      <el-table-column prop="duration" label="时长" width="60">
        <template slot-scope="scope">
          {{ scope.row.duration }}h
        </template>
      </el-table-column>
      <el-table-column prop="content" label="训练内容"></el-table-column>
      <el-table-column prop="coachRemark" label="教练备注"></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'StudentProgress',
  props: {
    studentId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      studentInfo: {},
      trainingRecords: []
    }
  },
  async mounted() {
    await this.loadStudentProgress()
  },
  methods: {
    async loadStudentProgress() {
      // 模拟数据
      this.studentInfo = {
        realName: '张三',
        phone: '13800138000',
        courseType: 'c1',
        currentSubject: 'subject2',
        totalHours: 50,
        completedHours: 32,
        remainingHours: 18,
        subject2Progress: 80,
        subject3Progress: 40
      }

      this.trainingRecords = [
        {
          date: '2023-10-25',
          coachName: '张教练',
          subject: 'subject2',
          duration: 2,
          content: '倒车入库、侧方停车',
          coachRemark: '掌握较好，需要注意车速控制'
        },
        {
          date: '2023-10-23',
          coachName: '张教练',
          subject: 'subject2',
          duration: 2,
          content: '坡道定点、直角转弯',
          coachRemark: '坡道起步需要加强练习'
        }
      ]
    },

    getSubjectText(subject) {
      const subjects = {
        'subject1': '科目一',
        'subject2': '科目二',
        'subject3': '科目三',
        'subject4': '科目四'
      }
      return subjects[subject] || subject
    }
  }
}
</script>

<style scoped>
.student-progress {
  padding: 10px;
}

.stats {
  margin-bottom: 20px;
}

.stat-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  padding: 5px 0;
}

.stat-item .label {
  color: #666;
}

.stat-item .value {
  font-weight: bold;
  color: #409EFF;
}

.subject-progress {
  margin-top: 10px;
}

.subject-item {
  margin-bottom: 15px;
}

.subject-item span {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
}
</style>
